import { render, staticRenderFns } from "./mediationRates.vue?vue&type=template&id=f75e1b64&scoped=true&"
import script from "./mediationRates.vue?vue&type=script&lang=js&"
export * from "./mediationRates.vue?vue&type=script&lang=js&"
import style0 from "./mediationRates.vue?vue&type=style&index=0&id=f75e1b64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75e1b64",
  null
  
)

export default component.exports